import init from 'moment-duration-format'
import moment from 'moment'

init(moment)


// WEBPACK FOOTER //
// ./src/vendor/moment-duration-format.js